module.exports = __webpack_public_path__ + "components/rewards/dragon-lodge/static/logo-526619d70c2f16d7ddb1e92ba0d602df.webp";